module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"da":{"title":"Du burde ikke være her!","message":"Du har ikke de nødvendige brugerettigheder til at se indholdet på denne side. Prøv venligst igen med en anden brugerkonto."}}')
  delete Component.options._Ctor
}
